var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStreamlineLegal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_86_151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.856934 22.7829L13.7141 22.7829L0.856934 22.7829ZM11.9998 22.7829L11.9998 18.4971L2.57122 18.4971L2.57122 22.7829",
    fill: "#FFFBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.856934 22.7829L13.7141 22.7829M11.9998 22.7829L11.9998 18.4971L2.57122 18.4971L2.57122 22.7829",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3487 1.71843L7.20291 7.86419C6.53344 8.53367 6.53344 9.61909 7.20291 10.2886L9.9182 13.0039C10.5877 13.6733 11.6731 13.6733 12.3426 13.0039L18.4883 6.85808C19.1578 6.18861 19.1578 5.10319 18.4883 4.43372L15.773 1.71843C15.1036 1.04896 14.0181 1.04896 13.3487 1.71843Z",
    fill: "white",
    stroke: "#FFFBF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4282 9.92571L23.1425 17.64",
    stroke: "#FFFBF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_86_151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineLegal);
export default __webpack_public_path__ + "static/media/streamline_legal.ba52847a1ba70fa383cc387441136f68.svg";
export { ForwardRef as ReactComponent };